import { css } from 'styled-components';
import token from 'styled-token';
import { StyledDialogClose } from '../components/DialogClose/DialogClose.styles';

/** @mixin dialogCloseMixin */
/**
 * Positions the close button on dialog components.
 *
 * @example
 * import { dialogCloseMixin, CloseButton } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${dialogCloseButton}
 * `;
 *
 * <Component>
 *      <CloseButton />
 * </Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
export var dialogCloseMixin = function dialogCloseMixin(props) {
  return css(["position:relative;& ", "{position:absolute;z-index:", ";}"], StyledDialogClose, token('zIndices.dialog')(props));
};